import { render, staticRenderFns } from "./LoadingWrapper.vue?vue&type=template&id=28a87640"
import script from "./LoadingWrapper.vue?vue&type=script&lang=js"
export * from "./LoadingWrapper.vue?vue&type=script&lang=js"
import style0 from "./LoadingWrapper.vue?vue&type=style&index=0&id=28a87640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports